var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'c-round-checkbox': true,
  'c-round-checkbox--disabled': _vm.disabled | _vm.loading
}},[_c('label',{staticClass:"c-round-checkbox__label"},[_c('input',{staticClass:"c-round-checkbox__box",attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"input":_vm.$listeners.input}}),_c('span',{staticClass:"c-round-checkbox__checkmark",class:{'c-round-checkbox__checkmark--loading': _vm.loading}})])])}
var staticRenderFns = []

export { render, staticRenderFns }